// Mirrors backstage-service-sonarqube's SetupProjectRequest.cs and Models/Validation.cs, so invalid
// input is caught before the request instead of as a 400.
const sonarQubeKeyPattern =
  /^(?=.*[^0-9])(?!.*(_\.|\._))[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)*$/;
const singleLinePattern = /^[^\p{C}]*$/u;
const scannerArgPattern = /^[^\p{C}"\\]*$/u;
// ServiceGroupService.CleanRepositoryName's input pattern and Validation.RepositoryName. The service does the parsing
// and checks the organization; this only checks the input.
const repositoryInputPattern =
  /^(?:(?:https?:\/\/)?(?:www\.)?github\.com\/)?(?:(?<owner>[^/]+)\/)?(?<repo>[^/?#]+?)(?:\.git)?\/?(?:[/?#].*)?$/i;
const repositoryNamePattern = /^[A-Za-z0-9._-]{1,100}$/;

/** `{applicationKey}_`, which every project key in the service group must start with. */
export const projectKeyPrefix = (applicationKey: string) =>
  `${applicationKey.toLowerCase()}_`;

export const isValidProjectKey = (key: string, applicationKey: string) => {
  const prefix = projectKeyPrefix(applicationKey);
  return (
    key.length <= 400 &&
    key.length > prefix.length &&
    key.toLowerCase().startsWith(prefix) &&
    sonarQubeKeyPattern.test(key)
  );
};

/** A repository name, `org/name` or GitHub URL whose name is valid. */
export const isValidRepositoryName = (input: string) => {
  const repo = repositoryInputPattern.exec(input.trim())?.groups?.repo;
  return repo !== undefined && repositoryNamePattern.test(repo);
};

export const isValidProjectDescription = (description: string) =>
  description.length >= 4 &&
  description.length <= 256 &&
  scannerArgPattern.test(description);

export const isValidQualityGateName = (name: string) =>
  name.length > 0 && name.length <= 100 && singleLinePattern.test(name);
